import DisclaimerPage from "./DisclaimerPage";

export default DisclaimerPage;
